module.exports = "<nav> <div class=nav-wrapper> <div class=\"col s12\"> <a v-for=\"crumb in crumbs\" :href=crumb.href class=breadcrumb>{{crumb.label}}</a> <slot></slot> </div> </div> </nav>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/breadcrumbs/breadcrumbs.vue
 ** module id = 140
 ** module chunks = 0
 **/